<template>
    <div>

        <van-popup class="van_popup" v-model="showPopModel"
                   :style="{width: screenWidth + 'px'}" >
            <div style="text-align: right; margin-right: 20px; margin-bottom: 20px">
                <van-icon name="close" size="30" color="#FFFFFF" @click="clickCloseIcon"/>
            </div>

            <div style="padding-left: 50px" >
<!--                <Wp_image v-if="image" class="pop_img" :url="image"></Wp_image>-->
                <Wp_img_swipe :list="img_list"
                              :height="screenWidth-100 + 'px'"
                              :width="screenWidth-100 + 'px'"
                              @clickImageRequestIndex="clickImageRequestIndex"
                ></Wp_img_swipe>
            </div>

        </van-popup>
    </div>
</template>

<script>
    import Wp_img_swipe from "./Wp_img_swipe";
    export default {
        name: "Wp_pop_action",
        components: {Wp_img_swipe},
        props:{
            showPop:{type: Boolean, default: false},
            popData:{type: Array}

            // popData: [{
            //     start_time: "2020-01-14 15:10:43"
            //     createtime: "2020-01-17 12:27:03"
            //     act_name: "关于12月佣金提现通知"
            //     act_share_img: ""
            //     act_desc: ""
            //     end_time: "2020-01-20 23:59:59"
            //     show: 0
            //     act_type: "1,2,3,4,"
            //     act_content: "临近春节，为了让广大会员可在年前提现，本平台将于2020年1月份结算日提前至1月16日。↵↵       凡是在1月16日、17日、18日、19日、20日提现的会员，我们将在22号之前完成打款，21日后提现的群主顺延至下个月2月21日后打款，届时请您尽快在后台进行提现。↵↵       感谢您对万品京选平台的大力支持！"
            //     id: "A_1578985843000"
            //     pop_img: "http://api.wapg.cn/jd_union/images/20200117/d66247c9c21b5cd86adf90b8bfa9de6a.png"
            // }]
        },
        data(){
            return{
                showPopModel: false,
                // 屏幕宽
                screenWidth: window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
                // 屏幕高
                screeHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,

                img_list: [],

            }
        },
        created() {
            this.showPopModel = this.showPop;
            this.initPopDatas();
        },
        watch:{
            showPop(newValue){
                this.showPopModel = newValue;
            }
        },
        methods:{
            clickImageRequestIndex(index){
                if(this.popData && this.popData.length > 0) {
                    this.clickImage(this.popData[index])
                }
            },

            initPopDatas(){
                let _imgs = [];
                if(this.popData && this.popData.length > 0){
                    for(let i = 0; i < this.popData.length; i++){
                        _imgs.push({
                            img: this.popData[i].pop_img
                        })
                    }
                }
                this.img_list = _imgs;

            },

            clickImage(item){
                this.$log("1111 clickImage = ")
                this.$emit("clickImage", item)
            },

            clickCloseIcon(){
                this.showPopModel = false;
            }
        }
    }
</script>

<style scoped>
    .pop_img{
        line-height: 1px;
    }
    .van_popup{
        background-color: rgba(255, 255, 255, 0);
    }
</style>